<template lang="pug">
  span.ft_padding
    footer.text-xs-center
      span.copyright Copyright©2019 Otani Trading,Ltd. All Rights Reserved.
</template>

<script>

export default {
  name: 'CommonFooter',
  data () {
    return {
    }
  }
}

</script>

<style scoped lang="stylus">
//breakpoint
screen-xs = 600px
screen-sm = 960px

breakpoint(bpName)
    for name in bpName
        if name == 'xs'
            @media only screen and (max-width: screen-xs)
                {block}
        if name == 'sm'
            @media only screen and (max-width: screen-sm)
                {block}
.border_branch
  position absolute
  width 100%
  height 80px
  background url(../../../../static/images/border_branch.png) repeat-x
  background-size contain
  z-index 2
  margin -20px 0
  +breakpoint(sm)
    background-size cover

//Footer
.ft_padding
  display inline-block
  height 150px
  width 100%
footer
  position absolute
  bottom 0
  margin-bottom -35px
  @extend .border_branch
  background-position bottom -15px right 0
  .copyright
    font-size 0.8rem
    color #f2ebe0
    padding-top 50px
    display inline-block
    +breakpoint(xs)
      font-size 0.6rem

</style>



// WEBPACK FOOTER //
// src/app/pages/Landing/Footer.vue